export default __webpack_public_path__ + "static/media/Step3.d3bb03e3.png";